import {
  ErrorSkin,
  ErrorSkinOther,
  ErrorSkinSocket,
  PlaceholderInterface,
  PlaceholderInterfaceError,
  PlaceholderInterfaceHollow,
  PlaceholderInterfaceMech,
  PlaceholderSkin,
  PlaceholderSkinOther,
  PlaceholderSkinSocket,
  PlaceholderSkinSocketVertical
} from '../data/placeholderImages'

import OtherPlaceholderImage from '../assets/other_placeholder.png'
import OtherProPlaceholderImage from '../assets/other_pro_placeholder.png'
import { REACT_APP_IMAGE_BASE_URL } from '../environment'

const baseUrl = REACT_APP_IMAGE_BASE_URL || `${process.env.PUBLIC_URL}/product-images/`
// /*local images*/ const baseUrl = `${process.env.PUBLIC_URL}/local-product-images/`

export function getProductImageUrl(imageName: string): string
export function getProductImageUrl(imageName: null | undefined): null | undefined
export function getProductImageUrl(imageName: string | null | undefined): string | null | undefined
export function getProductImageUrl(imageName: string | null | undefined): string | null | undefined {
  switch (imageName) {
    case '':
    case null:
    case undefined:
    case PlaceholderSkin:
    case PlaceholderSkinSocket:
    case PlaceholderSkinSocketVertical:
    case ErrorSkinSocket:
    case ErrorSkinOther:
    case ErrorSkin:
    case PlaceholderSkinOther:
    case PlaceholderInterface:
    case PlaceholderInterfaceError:
    case PlaceholderInterfaceHollow:
    case PlaceholderInterfaceMech:
    case OtherPlaceholderImage:
    case OtherProPlaceholderImage:
      return imageName
    default:
      return `${baseUrl}${imageName}`
  }
}
